import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { Button, TextField } from '@speeki/global-ui-components';

import { StandardForm } from '@components/atoms/StandardForm/StandardForm';

import { forgotPasswordEmailVar } from '@boot/reactiveVariables';
import { yupResolver } from '@hookform/resolvers/yup';
import { emailValidation } from '@shared/validations';

export const ForgotPasswordForm = () => {
    const { t } = useTranslation();
    const {
        formState: { errors, isValid },
        handleSubmit,
        register,
    } = useForm<ForgotPasswordFormValues>({
        mode: 'onChange',
        resolver: yupResolver(ForgotPasswordFormSchema),
    });

    const onSubmit = handleSubmit((data) => {
        forgotPasswordEmailVar(data.email);
    });

    return (
        <StandardForm noValidate onSubmit={onSubmit}>
            <TextField
                {...register('email')}
                className="htmlToImageIgnore"
                error={!!errors.email?.message}
                label={`${t('EMAIL')}`}
                message={
                    errors.email?.message ? t(errors.email?.message) : undefined
                }
                placeholder={t('EMAIL_PLACEHOLDER')}
                testId="ZM63kW8"
                type={'email'}
            />
            <StandardForm.Actions>
                <Button
                    disabled={!isValid}
                    fullWidth
                    testId="button_continue"
                    variant="primary"
                >
                    {t('CONTINUE')}
                </Button>
            </StandardForm.Actions>
        </StandardForm>
    );
};

const ForgotPasswordFormSchema = yup.object({
    email: emailValidation,
});

type ForgotPasswordFormValues = yup.InferType<typeof ForgotPasswordFormSchema>;
